import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InvoicingReportFilterModel } from 'src/app/models/invoicing/invoicing-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InvoicingReportService } from 'src/app/services/invoicing/invoicing-report.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-invoicing-kilograms',
  templateUrl: './invoicing-kilograms.component.html',
  styleUrls: ['./invoicing-kilograms.component.scss'],
  standalone: false
})
export class InvoicingKilogramsComponent implements OnInit, AfterViewInit {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;


  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filteredSubgroups: any[] = [];
  filtersHeight: number = 0;
  formInvoicingReportFilter: FormGroup = new FormGroup({});
  filterObserver?: ResizeObserver;
  filteredEnterprise: any[] = [];
  filteredSeller: any[] = [];
  listArticle: any[] = [];
  listBranch: any[] = [];
  listConcept: any[] = [];
  listEnterprise: any[] = [];
  listGroup: any[] = [];
  listSeller: any[] = [];
  listSubGroup: any[] = [];
  nameWindow: string = 'Informe de Facturación en Kg';
  projectName = ProjectName.projectName;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private conceptInvoicingService: ConceptInvoicingService,
    private dateConverterService: DateConverterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private groupService: GroupService,
    private headerService: HeaderService,
    private invoicingReportService: InvoicingReportService,
    private rentalPeriodService: RentalPeriodService,
    private subgroupService: SubgroupService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
  ) { this.validateForm(); }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getAllLists();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  async changeArticle(articleId: number | null) {
    if (articleId != 0 && articleId != null) {
      const response = await firstValueFrom(this.articleService.getArticleById(articleId));
      this.formInvoicingReportFilter.controls["groupId"].patchValue(response.groupId);
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(response.subgroupId);
    } else {
      this.formInvoicingReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  async changeBranch(branchId: number | null) {
    this.filterEnterpriseByBranchId(branchId);
    if (branchId != 0 && branchId != null) {
      this.getFirstEnterpriseByBranch(branchId);
    } else {
      this.formInvoicingReportFilter.controls["branchId"].patchValue(0);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeConceptInvoicing(conceptInvoicingId: number | null) {
    if (conceptInvoicingId === 0 || conceptInvoicingId === null || conceptInvoicingId === undefined) {
      this.formInvoicingReportFilter.controls["conceptInvoicingId"].patchValue(0);
    } else {
      this.formInvoicingReportFilter.controls["groupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeEnterprise(enterpriseId: number | null) {
    if (enterpriseId != 0 && enterpriseId != null) {
      const branchId = this.listEnterprise.find(x => x.value === enterpriseId)!.branchId;
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branchId);
      this.formInvoicingReportFilter.controls["conceptInvoicingId"].patchValue(branchId);
      this.formInvoicingReportFilter.controls["groupId"].patchValue(branchId);
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(branchId);
      this.formInvoicingReportFilter.controls["articleId"].patchValue(branchId);
    } else {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["articleId"].patchValue(0);
    } else {
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["groupId"].patchValue(0);
    }
    this.changeFilter();
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubGroup.find(x => x.value === subgroupId)!.groupId;
      this.formInvoicingReportFilter.controls["groupId"].patchValue(groupId);
      this.formInvoicingReportFilter.controls["articleId"].patchValue(0);
      this.filterSubgroupByGroupId(groupId);
    } else {
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilter();
  }

  async clear() {
    this.changeFilter();
    this.validateForm();
    this.getAllLists();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const modelRentalReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
      try {
        const response = await firstValueFrom(this.invoicingReportService.exportInvoicingReportInvoicingKilograms(modelRentalReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe de Facturación total Kg.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterEnterpriseByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredEnterprise = this.listEnterprise.filter(x => x.branchId === branchId);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    } else {
      this.filteredEnterprise = this.listEnterprise;
    }
  }

  filterSellerByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredSeller = this.listSeller.filter(x => x.branchId === branchId);
      this.formInvoicingReportFilter.controls["sellerId"].patchValue(0);
    } else {
      this.filteredSeller = this.listSeller;
    }
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubGroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formInvoicingReportFilter.get("subgroupId")?.value;
      const subgroupExists = this.listSubGroup.some(x => x.groupId === groupId && x.value === subgroupId);

      if (subgroupId && !subgroupExists) {
        this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubGroup;
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises, concepts, groups, subgroups, articles,] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
        firstValueFrom(this.conceptInvoicingService.getAllConceptsInvoicingForSelectAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
      ]);
      this.listBranch = branches;
      this.listEnterprise = enterprises;
      this.listArticle = articles;
      this.listConcept = concepts;
      this.listGroup = groups;
      this.listSubGroup = subgroups;
      this.filteredSubgroups = this.listSubGroup;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.changeBranch(branch.branchId);
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (!response) {
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formInvoicingReportFilter.controls["initialDate"].patchValue(this.dateConverterService.convertDatePreserveDay(rentalPeriod.initialDate));
      this.formInvoicingReportFilter.controls["finalDate"].patchValue(this.dateConverterService.convertDatePreserveDay(rentalPeriod.finalDate));
    } catch (error) {
      console.error("Error al consultar el periodo de alquiler:", error);
    }
  }

  async send() {
    Object.keys(this.formInvoicingReportFilter.controls).forEach(key => {
      const control = this.formInvoicingReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingReportFilter.valid) {
      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;

      if (modelInvoicingReportFilter.finalDate < modelInvoicingReportFilter.initialDate) {
        this.toastHandlerService.showToast('warning', 'La fecha final no puede ser menor al fecha inicial.');
        return;
      }

      try {
        this.dataReport = await firstValueFrom(this.invoicingReportService.getInvoicingKilograms(modelInvoicingReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      initialDate: {
        required: 'El campo Desde es obligatorio.'
      },
      finalDate: {
        required: 'El campo Hasta es obligatorio.'
      },
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  validateForm() {
    this.formInvoicingReportFilter = this.formBuilder.group({
      initialDate: ['', [Validators.required]],
      finalDate: ['', [Validators.required]],
      branchId: [0, [CustomValidators.numberOnlyValidator()]],
      enterpriseId: [0, [CustomValidators.numberOnlyValidator()]],
      conceptInvoicingId: [0, [CustomValidators.numberOnlyValidator()]],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
    });
  }
}